<script>
import { computedPbxBasePlans, computedPbxCallingPlans, computedPbxPlans, PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import mixin from '@/plans/mx/shopping-cart';
import { tollFreeNumberStore, phoneNumberStorage } from './store';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import { isBizPlusContext, isProPlusContext } from '../ZOOM_MEETING/common/utils';
import { phonePlanUnitMap } from './helper/constants'

export default {
  mixins: [mixin],
  computed: {
    selectedPbxPlans() {
      return computedPbxPlans(this.getSelectedPlans);
    },
    pbxBasePlan() {
      return computedPbxBasePlans(this.selectedPbxPlans)[0];
    },
    pbxCallingPlan() {
      const callingPlans = computedPbxCallingPlans(this.selectedPbxPlans)
      return callingPlans.length > 1 ? callingPlans: callingPlans[0];
    },
    pbxTFPlan() {
      const tfPlans = this.selectedPbxPlans.filter(item => item.sub_type === PBX_SUB_TYPES.TOLLFREE);
      return tfPlans.length > 1 ? tfPlans: tfPlans[0];
    },
    pbxPNPlan(){
       return this.selectedPbxPlans.filter(item => item.sub_type === PBX_SUB_TYPES.PHONE_NUMBER);
    },
    pbxAddonPlans() {
      return this.selectedPbxPlans.filter(item => [PBX_SUB_TYPES.FEATURE, PBX_SUB_TYPES.UNLIMITED_ADDON].includes(item.sub_type));
    },
    isShowRmvBtn(){
      if(this.$context.is.checkoutPage) return true;
      return false;
    },
  },
  methods: {
    removeTFPlan(plan) {
      return (
        <ZmButton
          type="link"
          aria-label={`${this.$t('billing.common.remove')} ${this.$t(plan.planNameKey)}`}
          onClick={() => {
            tollFreeNumberStore.state.pickedNumberList = [];
            phoneNumberStorage.update('tollFreeNumberState', tollFreeNumberStore.state);
            this._dispatch('remove', plan);
            this.$tracking.orderSummary(
              `remove ${this.$pkg.components.addon ? 'add-on product' : 'product'} - ${this.$t(plan.planNameKey)}`,
            );
          }}
        >
          {this.$t('billing.common.remove')}
        </ZmButton>
      );
    },
    removePNPlan(plan) {
      return (
        <ZmButton
          type="link"
          aria-label={`${this.$t('billing.common.remove')} ${this.$t(plan.planNameKey)}`}
          onClick={() => {
            this._dispatch('remove', plan);
          }}
        >
          {this.$t('billing.common.remove')}
        </ZmButton>
      );
    },
    $renderCallingPlanContent(plan){
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(this.$t(`billing.pbx.cart_name.${plan.category}`), this.mx_price(plan))}
          {this.mx_discount(plan.plan_code)}
          <h2 class="opc-cart-item__text">
            { plan.cartInfo.selected_number > 1 ? this.$t('billing.pbx.x_calling_plan', [plan.cartInfo.selected_number]) : this.$t('billing.pbx.one_calling_plan')}
          </h2>
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_edit(plan)}
        </div>
        )
    },
    $renderTollFreePlanContent(plan){
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(this.$t(`billing.pbx.cart_name.${plan.category}`), this.mx_price(plan))}
          {this.mx_discount(plan.plan_code)}
          <h2 class="opc-cart-item__text">
            { plan.cartInfo.selected_number } {this.$t('billing.planform.unit.number')}
          </h2>
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_edit(plan)}
          {this.isShowRmvBtn && this.removeTFPlan(plan)}
        </div>
        )
    },
    $renderCallingPlan() {
      return !!this.pbxCallingPlan && (
         Array.isArray(this.pbxCallingPlan) ?
          this.pbxCallingPlan.map(plan =>(
            this.$renderCallingPlanContent(plan)
          ))
         :this.$renderCallingPlanContent(this.pbxCallingPlan)
      );
    },
    $renderTollFreePlan() {
       return !!this.pbxTFPlan  && (
         Array.isArray(this.pbxTFPlan) ?
          this.pbxTFPlan.map(plan =>(
            this.$renderTollFreePlanContent(plan)
          ))
         :this.$renderTollFreePlanContent(this.pbxTFPlan)
      );
    },
    $renderPNplan(){
      return !!this.pbxPNPlan  && (
          this.pbxPNPlan.map(plan =>(
              (
                <div class="pbx-cart-part">
                  {this.mx_subTitle(this.$t(`billing.pbx.cart_name.${plan.category}`), this.mx_price(plan))}
                  {this.mx_discount(plan.plan_code)}
                  <h2 class="opc-cart-item__text">
                    { plan.cartInfo.selected_number } {this.$t('billing.planform.unit.number')}
                  </h2>
                  {this.mx_cycle(plan.billing_cycle)}
                  {this.mx_edit(plan)}
                  { this.isShowRmvBtn && this.removePNPlan(plan)}
                </div>
            )
          ))
     )
    },
    $renderBasePlan() {
      if(!this.pbxBasePlan) return null
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(this.$t('billing.pbx.metered_calling_credits'), this.pbxBasePlan.amount)}
          {this.mx_discount(this.pbxBasePlan.plan_code)}
          {this.mx_cycle(this.pbxBasePlan.billing_cycle)}
          {this.mx_edit(this.pbxCallingPlan)}
        </div>
      )
    },
    $renderPrice() {
      const hasPbxNoneBasePlans = plansof(this.selectedPbxPlans).type(planTypes.ZOOM_PHONE).not().sub_type('BASE').has();
      if ((isBizPlusContext) && !hasPbxNoneBasePlans) return; // isBizPlusContext unnecessary, only for descoping risks
      if (isProPlusContext) return; // PRO PLUS HARD, not consider pbx + pro plus mix buy case. For Pro plus context, need remove cart render, phone render will in pro plus context
      if (!this.selectedPbxPlans.length) return;
      return (
        <div class="opc-cart-item">
          <h1 class="opc-cart-item__title text-capitalize">{ this.$t('billing.planform.title.zoomphone') }</h1>
          { this.$renderCallingPlan() }
          { this.$renderTollFreePlan() }
          { this.$renderBasePlan() }
          { this.$renderPNplan()}
          <div class="pbx-cart-part">
            {
              this.pbxAddonPlans.map(item => (
                <div key={item.plan_code}>
                  {this.mx_subTitle(this.$t(`billing.pbx.plan_name.${item.category}`), item.amount * item.cartInfo.selected_number)}
                  {this.mx_discount(item.plan_code)}
                  <h2 class="opc-cart-item__text">
                    { item.cartInfo.selected_number } {this.$t(phonePlanUnitMap[item.type] || 'billing.planform.unit.number')}
                  </h2>
                  {this.mx_cycle(item.billing_cycle)}
                  {this.mx_edit(item)}
                  {this.isShowRmvBtn && this.mx_remove(item)}
                </div>
              ))
            }
          </div>
        </div>
      );
    },
  },
};
</script>
<style lang="scss">
.pbx-cart-part {
  margin-bottom: 10px;
}
</style>
